export enum UniversityFeatureFlags {
    STAFF_PROFILES = "staffProfiles",
}
